import { makeAutoObservable } from 'mobx';
import { axiosBarwisInstance } from 'libs/axios/axios.lib';
import apolloClient from 'libs/apollo/apollo.lib';
import storage from 'libs/storage';
import { gql } from '@apollo/client';
import layoutStore from './layout.store';

class UserStore {
  isAuthenticated = false;
  isAuthenticating = false;
  isLoggingOut = false;
  isLoading = false;
  user = null;
  redirectToLogin = false;
  constructor() {
    makeAutoObservable(this);
  }

  setIsAuthenticated(isAuthenticated) {
    this.isAuthenticated = isAuthenticated;
    return this.isAuthenticated;
  }

  getIsAuthenticated() {
    return this.isAuthenticated;
  }

  setIsAuthenticating(isAuthenticating) {
    this.isAuthenticating = isAuthenticating;
    return this.isAuthenticating;
  }

  getIsAuthenticating() {
    return this.isAuthenticating;
  }

  setIsLoggingOut(isLoggingOut) {
    this.isLoggingOut = isLoggingOut;
    return this.isLoggingOut;
  }

  getIsLoggingOut() {
    return this.isLoggingOut;
  }

  setRedirectToLogin(redirectToLogin) {
    this.redirectToLogin = redirectToLogin;
    return this.redirectToLogin;
  }

  getRedirectToLogin() {
    return this.redirectToLogin;
  }

  setIsLoading(isLoading) {
    this.isLoading = isLoading;
    return this.isLoading;
  }

  getIsLoading() {
    return this.isLoading;
  }

  async setCsrfCookie() {
    try {
      await axiosBarwisInstance.get('/sanctum/csrf-cookie');
    } catch (error) {
      throw error;
    }
  }

  async checkAuth() {
    try {
      const query = gql`
        query {
          me {
            id
            first_name
            middle_name
            last_name
            username
            email
            phone
            avatar
            gender
            role {
              id
              name
            }
            barwisAdmin {
              id
            }
            barwisCoach {
              id
            }
            externalCoach {
              id
            }
            externalAdmin {
              id
            }
            athlete {
              id
            }
            client {
              id
            }
          }
        }
      `;
      const response = await apolloClient.query({
        query: query
      });
      if (response.data.me) {
        this.setUser(response.data.me);
        this.setIsAuthenticated(true);
        // layoutStore.setToastConfig({
        //   message: 'Successfully logged in!',
        //   color: 'success'
        // });
      }
    } catch (error) {
      this.setIsAuthenticated(false);
      throw error;
    }
  }

  async authenticate(email, password) {
    const platform = layoutStore.getPlatform();
    try {
      if (platform === 'mobile') {
        const response = await axiosBarwisInstance.post('api/sanctum/token', {
          email: email,
          password: password
        });
        await storage.set('token', response.data);
      } else {
        await this.setCsrfCookie();
        await axiosBarwisInstance.post('/login', {
          email: email,
          password: password
        });
      }

      await this.checkAuth();
    } catch (error) {
      let message;
      if (error.response) {
        message = error.response.data.message;
      }
      if (error.networkError) {
        message = error.networkError.result.message;
      }
      layoutStore.setToastConfig({
        message: "Login Failed, Username and password doesn't match",
        color: 'danger'
      });
      throw error;
    }
  }

  async logout() {
    try {
      const platform = layoutStore.getPlatform();
      this.setIsLoggingOut(true);
      if (platform === 'mobile') {
        const token = await storage.get('token');
        await axiosBarwisInstance.post('api/sanctum/revoke-token', null, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        await storage.remove('token');
      } else {
        await axiosBarwisInstance.post('/logout');
      }

      await apolloClient.resetStore();
      this.setIsLoggingOut(false);
      layoutStore.setToastConfig({
        message: 'Successfully logged out!',
        color: 'success'
      });
      await this.checkAuth();
    } catch (error) {
      console.log(error);
      this.setIsLoggingOut(false);
    }
  }

  async sendPasswordRestLink(email) {
    this.setIsLoading(true);
    try {
      const response = await axiosBarwisInstance.post('/forgot-password', {
        email: email
      });
      if (response && response.status === 200) {
        layoutStore.setToastConfig({
          message:
            'Password reset link sent successfully! Please check your email',
          color: 'success'
        });
      } else {
        throw new Error();
      }
    } catch (error) {
      this.setIsLoading(false);
      layoutStore.setToastConfig({
        message: 'Error sending password reset link',
        color: 'danger'
      });
      throw error;
    }
    this.setIsLoading(false);
  }

  setUser(user) {
    this.user = user;
    return this.user;
  }

  getUser() {
    return this.user;
  }
}

export default new UserStore();
